import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { createElement } from 'react';
import styled from 'styled-components';
import { ButtonGroupButtonType } from '../types.js';
import { ButtonGroupItem } from './ButtonGroupItem.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["value"];
var Container = styled.div.withConfig({
  displayName: "ButtonGroupContainer__Container",
  componentId: "sc-k3lqz1-0"
})(function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  switch (type) {
    case ButtonGroupButtonType.SEPARATE:
      return {
        display: "flex",
        flexWrap: "wrap",
        gap: "16px",
        minHeight: "60px",
        padding: "1px"
      };
    case ButtonGroupButtonType.GROUPED:
      return {
        backgroundColor: theme.neutralColors.white,
        borderRadius: "4px",
        border: "1px solid ".concat(theme.neutralColors.silver),
        display: "inline-flex",
        gap: "2px",
        height: "32px",
        padding: "1px",
        ":focus-within, :hover": {
          border: "1px solid ".concat(theme.neutralColors.charcoal)
        }
      };
  }
});
var ButtonGroupContainer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var ariaLabel = _ref2.ariaLabel,
    groupName = _ref2.groupName,
    items = _ref2.items,
    _onClick = _ref2.onClick,
    role = _ref2.role,
    selectedValue = _ref2.selectedValue,
    type = _ref2.type;
  return /*#__PURE__*/jsx(Container, {
    "aria-label": ariaLabel,
    ref: ref,
    role: role,
    type: type,
    children: items.map(function (_ref3) {
      var buttonItemValue = _ref3.value,
        buttonItemProps = _objectWithoutProperties(_ref3, _excluded);
      return /*#__PURE__*/createElement(ButtonGroupItem, _objectSpread(_objectSpread({}, buttonItemProps), {}, {
        key: buttonItemValue,
        startAdornment: buttonItemProps.startAdornment,
        label: buttonItemProps.label,
        active: selectedValue === buttonItemValue,
        hideLabel: buttonItemProps.startAdornment && type === ButtonGroupButtonType.GROUPED || false,
        value: buttonItemValue,
        name: groupName,
        onClick: function onClick() {
          return _onClick(buttonItemValue);
        },
        type: type
      }));
    })
  });
});
ButtonGroupContainer.displayName = "ButtonGroupContainer";

export { ButtonGroupContainer };
